import { Button } from "@mui/material";
import React from "react";

export default function CoreButton(props) {
  return (
    <Button variant="contained" {...props}>
      {props?.children}
    </Button>
  );
}
